export enum UpdateTarget {
  CustomRules = 'custom_rules',
  Menu = 'menu',
  OrdersConfig = 'orders_config',
  ReservationConfig = 'reservations_config',
}
